var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef, useMemo } from "react";
import { getMarginClassesFromQuiMarginToken, getPaddingClassesFromQuiPaddingToken } from "../../../utils/index.js";
import classNames from "classnames";
export const QuiBox = forwardRef((_a, ref) => {
    var { alignItems, alignSelf, bg, border, borderBottom, borderLeft, borderRadius, borderRight, borderTop, className, color, display, flexDirection, flexGrow, flexShrink, flexWrap, gap, justifyContent, margin, maxWidth, minHeight, minWidth, overflow, padding, position, text, textAlign, textOverflow, weight, whiteSpace } = _a, props = __rest(_a, ["alignItems", "alignSelf", "bg", "border", "borderBottom", "borderLeft", "borderRadius", "borderRight", "borderTop", "className", "color", "display", "flexDirection", "flexGrow", "flexShrink", "flexWrap", "gap", "justifyContent", "margin", "maxWidth", "minHeight", "minWidth", "overflow", "padding", "position", "text", "textAlign", "textOverflow", "weight", "whiteSpace"]);
    const classNameProps = useMemo(() => {
        const cn = classNames({
            [`qui-${text}`]: text,
            [`qui-align-items-${alignItems}`]: alignItems,
            [`qui-align-self-${alignSelf}`]: alignSelf,
            [`qui-bg-${bg}`]: bg,
            [`qui-border-${border}`]: border,
            [`qui-border-bottom-${borderBottom}`]: borderBottom,
            [`qui-border-left-${borderLeft}`]: borderLeft,
            [`qui-border-right-${borderRight}`]: borderRight,
            [`qui-border-top-${borderTop}`]: borderTop,
            [`qui-color-${color}`]: color,
            [`qui-d-${display}`]: display,
            [`qui-flex-direction-${flexDirection}`]: flexDirection,
            [`qui-flex-grow-${flexGrow}`]: flexGrow,
            [`qui-flex-shrink-${flexShrink}`]: flexShrink,
            [`qui-flex-wrap-${flexWrap}`]: flexWrap,
            [`qui-gap-${gap}`]: gap,
            [`qui-justify-content-${justifyContent}`]: justifyContent,
            [`qui-max-width-${maxWidth}`]: maxWidth,
            [`qui-min-height-${minHeight}`]: minHeight,
            [`qui-min-width-${minWidth}`]: minWidth,
            [`qui-overflow-${overflow}`]: overflow,
            [`qui-position-${position}`]: position,
            [`qui-radius-${borderRadius}`]: borderRadius,
            [`qui-text-${weight}`]: weight,
            [`qui-text-align-${textAlign}`]: textAlign,
            [`qui-text-overflow-${textOverflow}`]: textOverflow,
            [`qui-white-space-${whiteSpace}`]: whiteSpace,
        }, ...getPaddingClassesFromQuiPaddingToken(padding), ...getMarginClassesFromQuiMarginToken(margin), className);
        if (cn.length === 0)
            return {};
        return {
            className: cn,
        };
    }, [
        alignItems,
        alignSelf,
        bg,
        border,
        borderBottom,
        borderLeft,
        borderRadius,
        borderRight,
        borderTop,
        className,
        color,
        display,
        flexDirection,
        flexGrow,
        flexShrink,
        flexWrap,
        gap,
        justifyContent,
        margin,
        maxWidth,
        minHeight,
        minWidth,
        overflow,
        padding,
        position,
        text,
        textAlign,
        textOverflow,
        weight,
        whiteSpace,
    ]);
    return React.createElement("div", Object.assign({ ref: ref }, classNameProps, props));
});
QuiBox.displayName = "QuiBox";
